// The knowledge page editor (TipTap and the byte-stable Markdown save, about
// 160 KB gzip) is a separate chunk that the browser fetches only when someone
// edits a page. scripts/build-ui.mjs splits it out of the main bundle, and
// test/ui-bundle-dev-tools.mjs checks that it stays out.
export const loadKnowledgeEditor = () => import('./knowledge-editor');
